import type {
  CostBenefitSnapshot,
  GoalSnapshotResponse,
  ProductCostsData,
  ProductCostsSource,
} from "@repo/shared/types";
import { getWithToken } from "../_client";

const BASE = "/public/flow/portfolios";

export function getPublicPortfolioPortfolioSnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${portfolioId}/snapshot/portfolio`, token);
}

export function getPublicPortfolioXraySnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${portfolioId}/snapshot/xray`, token);
}

export function getPublicPortfolioAssetAllocationSnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(
    `${BASE}/${portfolioId}/snapshot/asset-allocation`,
    token,
  );
}

export function getPublicPortfolioHistoricalReturnSnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(
    `${BASE}/${portfolioId}/snapshot/historical-return`,
    token,
  );
}

export function getPublicPortfolioForecastSnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${portfolioId}/snapshot/forecast`, token);
}

export function getPublicPortfolioCostSnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${portfolioId}/snapshot/cost`, token);
}

export function getPublicPortfolioExpectedValueSnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(
    `${BASE}/${portfolioId}/snapshot/expected-value`,
    token,
  );
}

// QP-177 — existing portfolio comparison snapshots (followup sessions)
/** QL-416 — cost/benefit comparison; the existing side is embedded in the payload. */
export function getPublicPortfolioCostBenefitSnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse<CostBenefitSnapshot>>(
    `${BASE}/${portfolioId}/snapshot/cost-benefit`,
    token,
  );
}

export function getPublicExistingXraySnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/${portfolioId}/snapshot/existing-xray`, token);
}

export function getPublicExistingAssetAllocationSnapshot(token: string, portfolioId: string) {
  return getWithToken<GoalSnapshotResponse>(
    `${BASE}/${portfolioId}/snapshot/existing-asset-allocation`,
    token,
  );
}

// QL-417 — public mirror of `getPortfolioProductCosts`.
export function getPublicPortfolioProductCosts(
  token: string,
  portfolioId: string,
  source: ProductCostsSource,
  lang: string,
) {
  return getWithToken<ProductCostsData>(
    `${BASE}/${portfolioId}/product-costs?source=${source}&lang=${encodeURIComponent(lang)}`,
    token,
  );
}
